import { time } from "echarts";

export class DeviceSample {
    id: string;
    deviceId: string;
    time: Date;
    managed: boolean;
    growthPercent: number;
    newRootsCount: number;
    rootHealthScore: number;
    rootColor: string;
    growthPattern: string;
    dominantDirection: string;
    fungalPresence: boolean;
    imageQuality: string;
    imageUrl: string; // URLs 
    observation: string;
    metadata: string;
    managedAt: Date;
    createdAt: Date;
    updatedAt: Date;
    createdBy: string;
    updatedBy: string;

    private spanishNames?: Record<string, string> = {
        id: "identificador",
        
        deviceId: "ID del dispositivo",
        time: "fecha y hora",
        managed: "gestionado",
        growthPercent: "porcentaje de crecimiento",
        newRootsCount: "cantidad de raíces nuevas",
        rootHealthScore: "puntaje de salud radicular",
        rootColor: "color de raíces",
        growthPattern: "patrón de crecimiento",
        dominantDirection: "dirección dominante",
        fungalPresence: "presencia de hongos",
        imageQuality: "calidad de imagen",
        imageUrl: "imágen",
        observation: "observación",
        metadata: "metadatos",
        managedAt: "gestionado en",
        createdAt: "creado en",
        updatedAt: "actualizado en",
        createdBy: "creado por",
        updatedBy: "actualizado por",
    };

    constructor(data?: Partial<DeviceSample>) {
        this.id = data?.id ?? "";
        this.time = data?.time ? new Date(data.time) : new Date();
        this.deviceId = data?.deviceId ?? "";
        this.managed = data?.managed ?? false;
        this.growthPercent = data?.growthPercent ?? 0;
        this.newRootsCount = data?.newRootsCount ?? 0;
        this.rootHealthScore = data?.rootHealthScore ?? 5;
        this.rootColor = data?.rootColor ?? "";
        this.growthPattern = data?.growthPattern ?? "";
        this.dominantDirection = data?.dominantDirection ?? "";
        this.fungalPresence = data?.fungalPresence ?? false;
        this.imageQuality = data?.imageQuality ?? "";
        this.imageUrl = data?.imageUrl ?? "";
        this.observation = data?.observation ?? "";
        this.metadata = data?.metadata ?? "";
        this.managedAt = data?.managedAt ? new Date(data.managedAt) : new Date();
        this.createdAt = data?.createdAt ? new Date(data.createdAt) : new Date();
        this.updatedAt = data?.updatedAt ? new Date(data.updatedAt) : new Date();
        this.createdBy = data?.createdBy ?? "";
        this.updatedBy = data?.updatedBy ?? "";
    }

    getSpanishName(propertyName: string): string {
        if (this.spanishNames && this.spanishNames[propertyName]) {
            return this.spanishNames[propertyName];
        }
        return propertyName;
    }

    toPlainObject(): Record<string, any> {
        return {
            id: this.id,
            
            deviceId: this.deviceId,
            time: this.time,
            managed: this.managed,
            growthPercent: this.growthPercent,
            newRootsCount: this.newRootsCount,
            rootHealthScore: this.rootHealthScore,
            rootColor: this.rootColor,
            growthPattern: this.growthPattern,
            dominantDirection: this.dominantDirection,
            fungalPresence: this.fungalPresence,
            imageQuality: this.imageQuality,
            imageUrl: this.imageUrl,
            observation: this.observation,
            metadata: this.metadata,
            managedAt: this.managedAt,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            createdBy: this.createdBy,
            updatedBy: this.updatedBy,
        };
    }

    // Helper methods for business logic
    isComplete(): boolean {
        return this.managed && 
               this.growthPercent >= 0 && 
               this.newRootsCount >= 0 && 
               this.rootHealthScore > 0 && 
               this.rootColor.trim() !== '' &&
               this.growthPattern.trim() !== '' &&
               this.imageQuality.trim() !== '';
    }

    getPendingDays(): number {
        const now = new Date();
        const diffTime = Math.abs(now.getTime() - this.time.getTime());
        return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    }

    getHealthScoreColor(): string {
        if (this.rootHealthScore >= 8) return '#4CAF50'; // Verde
        if (this.rootHealthScore >= 6) return '#FF9800'; // Naranja
        if (this.rootHealthScore >= 4) return '#FFC107'; // Amarillo
        return '#F44336'; // Rojo
    }

    getGrowthCategory(): string {
        if (this.growthPercent >= 5) return 'Excelente';
        if (this.growthPercent >= 3) return 'Bueno';
        if (this.growthPercent >= 1) return 'Moderado';
        return 'Bajo';
    }
}
